import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['closeIcon', 'alert'];

  connect() {
    this.open()
  }

  open() {
    this.alertTarget.classList.add("vc-alert--show")
  }

  close() {
    this.alertTarget.classList.add("vc-alert--closed")
    this.alertTarget.classList.remove("vc-alert--show")
  }
}
